module.exports = __webpack_public_path__ + "static/podcast-hero-desktop.129992c8.webp";